import useCheckMobileScreen from "../hook/useCheckMobileScreen";
import React from 'react';

export const withHooksHOC = (Component) => {
  return (props) => {
    let {isMobile , isDesktop , isTablet} = useCheckMobileScreen();

    return <Component isMobile={isMobile} isDesktop={isDesktop} isTablet={isTablet} {...props} />;
  };
};